<div class="wrapper"  [ngStyle]="isArabic ? { 'direction': 'rtl' } : {}">
  <label class="m-0 text-center text-black "  [innerHTML]="'second-pw-hint' | translate"></label>
  <label class="mb-3 text-center text-black ">({{'6-digits-hint'|translate}})</label>

  <div class="form-inline justify-content-center mb-3">
    <input *ngFor="let item of arrayCount; let index = index;" maxlength="1" type="password"
      class="form-control char-input" readonly [disabled]="carItems | checkArray: index"
      (focus)="putOrdinalNum(index, $event)" (blur)="onPropertyChange(index,$event)">
  </div>

  <div class="text-center text-black ">
    <label *ngIf="isEnglish && ordinalNum >= 0">Please enter {{ordinalNum +1 | ordinal}} character from your PIN</label>
    <label *ngIf="isArabic && ordinalNum >= 0">يرجى إدخال الحرف رقم {{ordinalNum +1 }}  من الرقم السرى الخاص بك</label>
  </div>

  <div class="text-center mb-3">
    <div class="simple-keyboard"></div>
  </div>

  <div class="text-center">
    <button type="button" (click)="submitSecAuth()" class="btn btn-primary">{{'submit'|translate}}</button>
  </div>
</div>
